// Shading must own its light even when the UI hides its sun during a run.
export const ensureShadingSun = (scene, THREE, ranges, center, scale) => {
  const existing = scene.getObjectByName('sunLight');

  const [minx, miny, maxx, maxy, maxz] = ranges;
  const width = maxx - minx;
  const height = maxy - miny;
  if (![minx, miny, maxx, maxy, maxz, center?.[0], center?.[1], scale].every(Number.isFinite) || width <= 0 || height <= 0 || scale <= 0) {
    const error = new Error('Shading scene bounds are not ready.');
    error.code = 'SHADING_SCENE_NOT_READY';
    throw error;
  }

  const light = existing?.isDirectionalLight ? existing : new THREE.DirectionalLight(0xffffff, 1);
  light.name = 'sunLight';
  light.castShadow = true;
  light.shadow.bias = -0.001;
  light.shadow.radius = 0;
  light.shadow.mapSize.set(2048, 2048);
  const r = Math.max(1, (maxz - 100) / 50);
  Object.assign(light.shadow.camera, {
    far: 500,
    left: (-width / 3) * 2,
    right: (width / 3) * 2,
    top: (height / 7) * r * 2,
    bottom: (-height / 7) * r * 2,
    zoom: 1,
  });
  light.shadow.camera.updateProjectionMatrix();
  light.target.position.set(((minx + maxx) / 2 - center[0]) * scale, 0, ((miny + maxy) / 2 - center[1]) * scale);
  scene.add(light, light.target);
  return light;
};
